<template>

  <div class="full_page">

    <h2>{{road_details.data.DBA}} / {{road_details.data.StoreName}} / {{road_details.data.LicenseName}}</h2>
    <h4>{{road_details.data.Address}} - {{road_details.data.License}} </h4>

    <template v-if="road_details.data.Visited === 'YES'">
      <h5 class="text-color-green">This Dispensary was visited</h5>
      <button @click="set_road_field(road_details.data.id,'Visited','')" class="action_button">Mark as NOT Visited</button>
    </template>
    <template v-else>
      <h5  class="text-color-red">This Dispensary was NOT visited</h5>
      <button @click="set_road_field(road_details.data.id,'Visited','YES')" class="action_button">Mark as Visited</button>
    </template>

<!--    <template v-if="road_details.data.Status === 'Active'">-->
<!--      Status: Active-->
<!--      <button @click="set_road_field(road_details.data.id,'Status','')">Mark as NOT Active</button>-->
<!--    </template>-->
<!--    <template v-else>-->
<!--      Status: NOT Active-->
<!--      <button @click="set_road_field(road_details.data.id,'Status','Active')">Mark as Active</button>-->
<!--    </template>-->

    <div class="row">

      <div class="col-3">
        Buyer Name
        <input
            size="30%"
            type="text"
            id="BuyerName"
            class="form-control"
            :value="road_details.data.BuyerName"
            @input="road_details.data.BuyerName = $event.target.value"
            @blur="set_road_field(road_details.data.id,'BuyerName',road_details.data.BuyerName)"
        >
      </div>

      <div class="col-3">
        Call Email
        <input
            size="30%"
            type="text"
            id="CallEmail"
            class="form-control"
            :value="road_details.data.CallEmail"
            @input="road_details.data.CallEmail = $event.target.value"
            @blur="set_road_field(road_details.data.id,'CallEmail',road_details.data.CallEmail)"
        >
      </div>

      <div class="col-3">
        Business Email
        <input
            size="30%"
            type="text"
            id="BusinessEmail"
            class="form-control"
            :value="road_details.data.BusinessEmail"
            @input="road_details.data.BusinessEmail = $event.target.value"
            @blur="set_road_field(road_details.data.id,'BusinessEmail',road_details.data.BusinessEmail)"
        >
      </div>

      <div class="col-3">
        Zone
        <input
            size="30%"
            type="text"
            id="Zone"
            class="form-control"
            :value="road_details.data.Zone"
            @input="road_details.data.Zone = $event.target.value"
            @blur="set_road_field(road_details.data.id,'Zone',road_details.data.Zone)"
        >
      </div>

    </div>

    <br/>

    <h4>Nearest Dispensaries</h4>
    <table class="table table-striped table-bordered table-hover table-condensed align_left">
      <thead>
      <tr>
        <th>#</th>
        <th>Visited</th>
        <th>Miles</th>
        <th>License</th>
        <th>DBA</th>
        <th>Address</th>
        <th>Zone</th>
      </tr>
      </thead>
      <tbody class="align_left">
      <tr v-for="dispensary in road_details.nearest" v-bind:key="dispensary.pos">
        <td>{{dispensary.pos}}</td>
        <td>{{dispensary.Visited}}</td>
        <td>{{dispensary.miles}}</td>
        <td style="white-space:nowrap;">{{dispensary.License}}</td>
        <td>{{dispensary.DBA}}</td>
        <td style="white-space:nowrap;">{{dispensary.Address}}</td>
        <td style="white-space:nowrap;">{{dispensary.Zone}}</td>
      </tr>
      </tbody>
    </table>

    <template v-if="show_unvisited_only === true">
      <button @click="toogleNonVisitedOnly(false)" class="action_button">Show NOT visited only</button>
    </template>
    <template v-else>
      <button @click="toogleNonVisitedOnly(true)" class="action_button">Show ALL</button>
    </template>
    <br />

    <div class="row">
      <div class="col-12">
        <div>
          <gmap-map :center="center" :zoom="map_zoom" style='width:100%;  height: 600px;' class="gmap">
              <gmap-marker
                  :key="index"
                  v-for="(m, index) in deliveries"
                  :position="m.position"
                  :icon="m.icon"
                  :label="{text: m.label, color: '#000', fontSize: '17px', fontWeight: '900'}"
              ></gmap-marker>
          </gmap-map>
        </div>
      </div>
    </div>

    <br />
    <br />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  data() {
    return {
      max_distance: 1609*2.5,
      center: { lat: 0.00, lng: 0.00 },
      map_zoom: 10,
      deliveries: [],
      currentPlace: null,
      show_unvisited_only: false,
    }
  },
  computed: {
    ...mapGetters({
      road_details: 'admin/road_details',
    }),
  },
  props: {
    license_number: null,
    id: null,
  },
  watch: {
    road_details: async function () {
      this.setGoogleMap();
    },
  },
  mounted() {

    this.center.lat = 34.05;
    this.center.lng = -118.38;
    this.map_zoom = 12;

    this.RoadsDetail();

  },
  destroyed() {

  },
  methods: {
    RoadsDetail () {
      this.$store.dispatch('admin/getRoadDetails', {'license_number': this.license_number, 'id': this.id, 'max_distance': this.max_distance});
    },
    toogleNonVisitedOnly(value) {
      this.show_unvisited_only = value;
      this.setGoogleMap();
    },
    set_road_field (record_id,fieldname,value) {
      this.$store.dispatch('admin/setRoadField', {record_id,fieldname,value,'license_number': this.license_number, 'max_distance': this.max_distance})
    },
    setGoogleMap() {

      this.deliveries = [];

      // https://stackoverflow.com/questions/8248077/google-maps-v3-standard-icon-shadow-names-equiv-of-g-default-icon-in-v2

      var icon_blue = {
        url: "https://maps.gstatic.com/mapfiles/ms2/micons/pink-pushpin.png",
        labelOrigin: {x: 20, y: +40}
      }

      this.center.lat = parseFloat(this.road_details.data.latitude);
      this.center.lng = parseFloat(this.road_details.data.longitude);
      this.map_zoom = 14;

      var driver_marker = {
        lat: parseFloat(this.road_details.data.latitude),
        lng: parseFloat(this.road_details.data.longitude),
      };

      this.deliveries.push({position: driver_marker, icon: icon_blue, label: this.road_details.data.DBA})

      var icon_green = {
        url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
        labelOrigin: {x: 20, y: +40}
      }

      var icon_red = {
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
        labelOrigin: {x: 20, y: +40}
      }

      this.road_details.nearest.forEach((dispensary) => {

          var driver_marker = {
            lat: parseFloat(dispensary.latitude),
            lng: parseFloat(dispensary.longitude),
          };

          if(dispensary.Visited === "YES") {
            if(this.show_unvisited_only === true) {
              this.deliveries.push({position: driver_marker, icon: icon_green, label: dispensary.DBA})
            }
          } else {
            this.deliveries.push({position: driver_marker, icon: icon_red, label: dispensary.DBA})
          }

      });

    }

  }
}

</script>

<style scoped>

.text-color-red {
  color:red;
}

.text-color-green {
  color:green;
}

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

.action_button {
  color: black;
  background-color: lightskyblue;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 3px;
  padding-bottom: 2px;
  border-radius: 5px;
  border-style: hidden;
  font-weight: 700;
  font-size: larger;
  margin-top: 12px;
  margin-bottom: 15px;
}


</style>

